import { TThunkAction } from '../../types/redux';
import { selectSeoTitle } from '../../selectors/seo';
import { PAGE_PATH } from '../../constants/config';
import { selectCurrentPage } from '../../selectors/pagination';
import { selectAppliedFilters } from '../../selectors/filters';

interface IParams {
  queryString: string;
  seoUrl?: string;
}

export const updateUrl = ({ queryString, seoUrl }: IParams): TThunkAction<Promise<void>> => {
  return async (_, getState) => {
    const state = getState();
    const documentTitle = selectSeoTitle(state);
    const page = selectCurrentPage(state);
    const filters = selectAppliedFilters(state);

    const search = queryString ? `?${queryString}` : '';
    const newUrl = seoUrl || `${PAGE_PATH}/${search}`;

    window.history.pushState({ filters, page }, documentTitle, newUrl);
  };
};
